import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import { Badge } from '@prisjakt/ui/badge';

type ExperimentProps = {
  $isCornerBadge?: boolean;
};

export const StyledBadge = styled(Badge)<ExperimentProps>`
  ${media.largeUp`
    margin-right: ${layout.measurements.spacing025};
  `}

  ${props =>
    props.$isCornerBadge &&
    css`
      border-top-right-radius: ${layout.measurements.spacing050};
      border-top-left-radius: 0;
      border-bottom-right-radius: 0;
    `}
`;
